/*
PURPOSE: Informational text component displayed below tabs to explain tab purpose

USE CASES:
- Display contextual information about what each tab contains
- Help users understand the purpose of different profile sections
- Provide clear navigation guidance without cluttering the tab bar

DOMAIN BOUNDARIES:
- Responsible for rendering tab description text
- Handles dynamic text substitution (e.g., [Name] variables)
- Should NOT handle tab state or navigation logic

ASSUMPTIONS:
- Light gray styling to differentiate from primary content
- Smaller font size for secondary nature
- Hidden on mobile devices to save space
- Centered text with "Learn more." link that has tooltip
*/

import React from 'react';
import { Tooltip } from 'react-tooltip';

interface TabDescriptorProps {
  /** The descriptive text to display */
  text: string;
  /** Additional CSS classes */
  className?: string;
  /** Optional tooltip ID for "Learn more" link */
  tooltipId?: string;
}

const TabDescriptor: React.FC<TabDescriptorProps> = ({ text, className = '', tooltipId = 'tab-spaces-info' }) => {
  return (
    <div
      className={`text-sm text-gray-400 text-center mt-4 mb-8 hidden md:block ${className}`}
      role="note"
      aria-label="Tab description"
    >
      {text}.{' '}
      <span
        className="text-coral-orange/70 cursor-help hover:text-coral-orange transition-colors"
        data-tooltip-id={tooltipId}
        data-tooltip-html="Coral has different spaces for different kinds of connection:<br/>• Talk about artists and music → Conversation<br/>• Talk to people directly → Dancefloor<br/>• See what someone's up to → Activity"
        data-tooltip-place="bottom"
      >
        Learn more.
      </span>
      <Tooltip id={tooltipId} className="z-50 max-w-xs !text-left" style={{ textAlign: 'left' }} />
    </div>
  );
};

export default TabDescriptor;
